import * as z from 'zod';

import { selectInputStringSchema } from '@/_schemas/generic/select-input';
import { stateQuerySchema } from '@/_schemas/generic/state-query-schema';

import { addressQuerySchema } from './address-query-schema';
import { recommendedActionSchema, validationDecisionSchema } from './address-validation-schema';

import { countryQueryLinkerSchema } from '../../../../_schemas/countries';

export const addressFormSchema = addressQuerySchema
  .pick({ id: true })
  .extend({
    address1: z.string(),
    address2: z.string(),
    postal_code: z.string(),
    city: selectInputStringSchema(true).nullable(),
    state: stateQuerySchema.nullable(),
    country: countryQueryLinkerSchema.refine((value) => !!value && value.id && value.id !== -1, 'Country is required'),
    region: z.string(),
    is_valid_postal_code: z.boolean(),
    validation_action: recommendedActionSchema.nullable(),
    validation_decision: validationDecisionSchema,
  })
  .superRefine((data, ctx) => {
    if (data.validation_action === 'CONFIRM' && data.validation_decision === 'pending') {
      ctx.addIssue({
        code: 'custom',
        message: 'Please validate this address and choose an option.',
        path: ['validation_decision'],
      });
    }
  });

export type AddressFormSchema = z.infer<typeof addressFormSchema>;
